import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';
import { AAPUserMetricsDetailResultDto } from './aap-user-metrics-detail-result-dto';

export class AAPUserMetricsResultDto {
    @Type(() => UserNameDisplayResultDto)
    aapUser: UserNameDisplayResultDto;

    totalProcessedCount: number;
    totalDeletedCount: number;
    totalSentToVendorEditCount: number;
    totalScannedStepCount: number;
    totalVerifyStepCount: number;
    totalSupervisorStepCount: number;
    totalMismatchCount: number;
    @Type(() => AAPUserMetricsDetailResultDto)
    detailsByDate: Array<AAPUserMetricsDetailResultDto>;

    get aapUserDisplayText(): string {
        return Utils.notNullAndDefined(this.aapUser) ? this.aapUser.displayName : '';
    }
}
